import React, { useState } from 'react';
import { bool, node, number, string } from 'prop-types';
import classNames from 'classnames';
import { SEARCH_PAGE_FILTER_ID } from '../../../util/uiHelpers';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './MainPanelHeader.module.css';
import { Button, SecondaryButton } from '../../../components';

const MainPanelHeader = props => {
  const {
    rootClassName,
    className,
    children,
    sortByComponent,
    isSortByActive,
    listingsAreLoaded,
    resultsCount,
    searchInProgress,
    noResultsInfo,
  } = props;

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const classes = classNames(rootClassName || css.root, className, { [css.isFilterHidden]: !isFilterOpen });

  return (
    <div className={classes} id={SEARCH_PAGE_FILTER_ID}>
      <div className={css.searchOptions}>
        <div className={css.searchResultSummary}>
          <span className={css.resultsFound}>
            {searchInProgress ? (
              <FormattedMessage id="MainPanelHeader.loadingResults" />
            ) : (
              <FormattedMessage
                id="MainPanelHeader.foundResults"
                values={{ count: resultsCount }}
              />
            )}
          </span>
        </div>
        <SecondaryButton
          className={css.toggleFilterButton}
          onClick={() => setIsFilterOpen(state => !state)}
        >
          <FormattedMessage id={`MainPanelHeader.toggleFilter${isFilterOpen ? 'Off' : 'On'}`} />
        </SecondaryButton>
      </div>
      <div className={css.mainPanelContent}>
        {isSortByActive ? (
          <div className={css.sortyByWrapper}>
            <span className={css.sortyBy}>
              <FormattedMessage id="MainPanelHeader.sortBy" />
            </span>
            {sortByComponent}
          </div>
        ) : null}
        <div className={css.filters}>
          {children}
        </div>
      </div>

      {noResultsInfo ? noResultsInfo : null}
    </div>
  );
};

MainPanelHeader.defaultProps = {
  rootClassName: null,
  className: null,
  resultsCount: null,
  searchInProgress: false,
  sortByComponent: null,
};

MainPanelHeader.propTypes = {
  rootClassName: string,
  className: string,
  listingsAreLoaded: bool.isRequired,
  resultsCount: number,
  searchInProgress: bool,
  sortByComponent: node,
};

export default MainPanelHeader;
